/* eslint-disable max-lines-per-function */
import searchCategoryFilterUtils from '@shared/composables/useUiHelpers/getSearchCategoryFilters';
import { getCategoryExactTitle } from '@shared/helpers/category/getCategoryExactTitle';
import { getEncodedCategoryHandle } from '@shared/helpers/category/getEncodedCategoryHandle';
import { ISearchCategoryFilter } from '@shared/types/search';
import { ISearchResponse } from '@unified-commerce/gpc-vue-storefront-search';
import { Collection } from '@unified-commerce/gpc-vue-storefront-shopify';

export const getSearchCategoryFilters = (
  searchQueryResponse: ISearchResponse,
  shopifyCategoriesResponse: readonly Collection[],
  fromSearchResults = false,
  preAppliedCategory = '',
): ISearchCategoryFilter[] => {
  // Step 1: Extract filter counts (e.g. { "autogen-handle": 123, ... }) from the search response
  const searchCategoryCollections =
    searchCategoryFilterUtils.extractSearchCollections(searchQueryResponse);
  if (!searchCategoryCollections) return [];
  // Step 2: Map search handles to Shopify category titles using collection metadata
  const titlesWithCount = searchCategoryFilterUtils.mapSearchHandlesToShopifyTitles(
    searchCategoryCollections,
    shopifyCategoriesResponse,
  );
  // Step 3: Convert titles and counts into full category filter objects
  const categoryFilters = searchCategoryFilterUtils.buildAllCategoryFilters(
    titlesWithCount,
    shopifyCategoriesResponse,
    searchCategoryCollections,
    getCategoryExactTitle,
    getEncodedCategoryHandle,
  );
  // Step 4: Filter, sort, and limit results depending on usage context
  return searchCategoryFilterUtils.pruneCategoryFilters(
    categoryFilters,
    fromSearchResults,
    preAppliedCategory,
  );
};
